"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const last_1 = __importDefault(require("lodash/last"));
const useResizeObserver_1 = __importDefault(require("./useResizeObserver"));
function useElementsOverflowingIndex({ ref, children, paddingSize, resizeDebounceTime, ignoreLast }) {
    const [size, setSize] = (0, react_1.useState)(null);
    const onResize = (0, react_1.useCallback)(({ borderBoxSize }) => {
        setSize(borderBoxSize.inlineSize);
    }, [setSize]);
    (0, useResizeObserver_1.default)({
        ref,
        callback: onResize,
        debounceTime: resizeDebounceTime
    });
    const [aggregatedChildLengths, setAggregatedChildLengths] = (0, react_1.useState)([]);
    const [indexToSplit, setIndexToSplit] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (ignoreLast) {
            const withoutLast = aggregatedChildLengths.slice(0, -1);
            const allInWithoutLast = !withoutLast.find(({ totalLength }) => totalLength > size - paddingSize);
            if (allInWithoutLast) {
                setIndexToSplit(-1);
            }
            else {
                const lastSize = aggregatedChildLengths.length > 0 ? (0, last_1.default)(aggregatedChildLengths).childLength : 0;
                setIndexToSplit(aggregatedChildLengths.findIndex(({ totalLength }) => totalLength > size - paddingSize - lastSize));
            }
        }
        else {
            setIndexToSplit(aggregatedChildLengths.findIndex(({ totalLength }) => totalLength > size - paddingSize));
        }
    }, [aggregatedChildLengths, size, setIndexToSplit, paddingSize, ignoreLast]);
    (0, react_1.useEffect)(() => {
        if (!ref.current)
            return;
        const childLengthsArray = [];
        let totalLength = 0;
        ref.current.childNodes.forEach((node) => {
            const childLength = node.clientWidth;
            totalLength += childLength;
            childLengthsArray.push({ childLength, totalLength });
        });
        setAggregatedChildLengths(childLengthsArray);
    }, [children, ref, setAggregatedChildLengths]);
    return indexToSplit;
}
exports.default = useElementsOverflowingIndex;
